<template>
  <svg
    viewBox="0 0 84 80"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="21.5" width="84" height="7" rx="3.5" fill="currentColor" />
    <rect y="36.5" width="84" height="7" rx="3.5" fill="currentColor" />
    <rect y="51.5" width="84" height="7" rx="3.5" fill="currentColor" />
  </svg>
</template>
<style>
svg path {
  fill: currentColor !important;
  stroke: currentColor !important;
}
</style>
